/**
 * Generates a random number between min and max (inclusive)
 * @param min - Minimum value (inclusive)
 * @param max - Maximum value (inclusive)
 * @returns A random number between min and max
 */
export function randomNumber(min, max) {
    const delta = max - min + 1;
    return Math.floor(Math.random() * delta) + min;
}
/**
 * Formats a number with German locale formatting
 * @param val - The number to format
 * @param decimals - Number of decimal places, defaults to 2
 * @param thousandsSeparator - Whether to include thousands separator, defaults to true
 * @returns Formatted number string with comma as decimal separator and dot as thousands separator
 */
export function formatNumber(val, decimals = 2, thousandsSeparator = true) {
    if (typeof val !== "number") {
        return formatNumber(0, decimals);
    }
    let res = val.toFixed(decimals).replace(".", ",");
    if (thousandsSeparator) {
        res = res.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }
    return res;
}
/**
 * Sums a specific property across an array of objects
 * @param items - Array of objects containing the property to sum
 * @param prop - The property key to sum
 * @returns The sum of all values for the specified property
 */
export function propSum(items, prop) {
    let total = 0;
    for (const item of items) {
        total += item[prop];
    }
    return total;
}
/**
 * Sums all numbers in an array
 * @param items - Array of numbers to sum
 * @returns The sum of all numbers in the array
 */
export function sum(items) {
    let total = 0;
    for (const item of items) {
        total += item;
    }
    return total;
}
/**
 * Rounds a number to the specified number of decimal places
 * @param val - The number to round
 * @param decimals - Number of decimal places, defaults to 2
 * @returns The rounded number
 */
export function round(val, decimals = 2) {
    const factor = Math.pow(10, decimals);
    return Math.round(val * factor) / factor;
}
/**
 * Clamps a value between a minimum and maximum value
 * @param value - The value to clamp
 * @param min - The minimum allowed value
 * @param max - The maximum allowed value
 * @returns The clamped value
 */
export function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
//# sourceMappingURL=math.util.js.map